import { useShopCartContext } from '../context'
import { ShopAdditionalSelectedProductProps, ShopCheckoutSideBarResponse } from '../models'
import useShopCart from './use-shop-cart'

interface UseAdditionalProductsHook {
  addAdditionalProductsToBasket: (
    mainProductId: string,
    additionalProducts: ShopAdditionalSelectedProductProps[],
    mainProductQuantity?: number
  ) => Promise<{ cartData: ShopCheckoutSideBarResponse; mainProductQuantity: number } | null>
}

const useShopAdditionalProducts = (): UseAdditionalProductsHook => {
  const { changeProductCartQuantity, addProductCart } = useShopCart()
  const { setCartData } = useShopCartContext()
  /** This function will add additional products of the main product to basket */
  const addAdditionalProductsToBasket = async (
    mainProductId: string,
    additionalProducts: ShopAdditionalSelectedProductProps[],
    mainProductQuantity?: number
  ): Promise<{ cartData: ShopCheckoutSideBarResponse; mainProductQuantity: number } | null> => {
    if (mainProductQuantity) {
      await changeProductCartQuantity(mainProductId, mainProductQuantity)
    }
    await addProductCart(additionalProducts).then(result => {
      if (result) {
        const cartData = result
        const mainProductQuantity = result.lineItems.find(product => product.referencedId === mainProductId)?.quantity
        setCartData(cartData)
        return { cartData, mainProductQuantity }
      }
    })
    return null
  }
  return {
    addAdditionalProductsToBasket,
  }
}

export default useShopAdditionalProducts
